import React from "react";
import { Link } from "react-router-dom";
import LegalPage, { P, Section, List, Mail } from "../../components/LegalPage";
import { SUPPORT_EMAIL } from "../../data/legalInfo";

export default function Support() {
  return (
    <LegalPage
      title="Support"
      subtitle="Help with your account, your league, and your lineup."
    >
      <Section title="Get in touch">
        <P>
          If you are signed in, the quickest way is Send Feedback in the account menu, top right.
          It sends your account and app version with the message, so we do not have to ask for
          them.
        </P>
        <P>
          Otherwise email <Mail address={SUPPORT_EMAIL} /> and we will get back to you within two
          business days. Tell us your account email, which league you are in, and what you were
          doing when the problem happened. A screenshot helps.
        </P>
      </Section>

      <Section title="Common questions">
        <P>
          <strong>My teams' scores have not updated.</strong> Scores refresh every few minutes while
          games are in progress and settle shortly after a game goes final. If a result is more than
          an hour stale, email us with the team and the week.
        </P>
        <P>
          <strong>I forgot my password.</strong> Use the reset link on the log in screen. The email
          arrives within a few minutes. Check your spam folder before writing to us.
        </P>
        <P>
          <strong>I never got my verification code.</strong> Request a new one from the verification
          screen. If it still does not arrive, the address may have a typo. Email us and we will
          sort it out.
        </P>
        <P>
          <strong>I need to change something in my league.</strong> League settings, draft order,
          and pick corrections are handled by your league commissioner, not by us.
        </P>
        <P>
          <strong>I want to delete my account.</strong> You can do it yourself from your account
          settings, or from the{" "}
          <Link to="/delete-account" style={{ color: "var(--color-brand)", textDecoration: "none" }}>
            delete your account
          </Link>{" "}
          page, which works whether or not you still have the app installed. Deletion is permanent.
          That page also sets out exactly what is erased and what your former leaguemates will still
          see.
        </P>
      </Section>

      <Section title="Reporting a bug">
        <P>Send us the following and we can usually reproduce it on the first try:</P>
        <List
          items={[
            "What you expected to happen, and what happened instead.",
            "The league and the week it happened in.",
            "Whether you were on the website or the app, and on what device.",
            "A screenshot of the screen where it went wrong.",
          ]}
        />
      </Section>

      <Section title="Reporting another manager">
        <P>
          If someone in your league is abusive, email <Mail address={SUPPORT_EMAIL} /> with the
          league name and what was said. We can suspend accounts that break the{" "}
          <Link to="/terms" style={{ color: "var(--color-brand)", textDecoration: "none" }}>
            terms of service
          </Link>
          .
        </P>
      </Section>
    </LegalPage>
  );
}
